<template>
    <div class="chat-input">
        <div class="chat-input-container">
            <!-- <button class="button-emoticon" @click="toggleEmoticonsKeyboard()">
                <img class="img-button" src="../assets/emoticon.png" alt="">
            </button> -->
            <input  
                ref="inputMessage"
                autocomplete="off"
                type="text" 
                name="input-message" 
                id="inputMessage" 
                class="input-message"
                placeholder="Digite aqui a sua mensagem"
                @submit.prevent="sendMessage()"
                @keyup.enter="sendMessage()"
                @touch="scrollChat()">
            <button @click="sendMessage()" 
                    @touch="sendMessage()" 
                    class="send-message"
                    ref="buttonMessage">
                <img src="../assets/arrow-message.png" class="img-send" alt="">        
            </button>
        </div>
    </div>
</template>
<script>
import Bus from '../main.js'
import { clearInterval } from 'timers';
export default {
    data: () => ({
        chatOutputs: '',
        chatOutputsIndex: 0,
        buttonStatus : 'able',
        colors:{}
    }),
    async created(){
        Bus.$on('sendEmoticon', this.addMessage)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    async mounted(){
        let input = this.$refs.inputMessage
        let button = this.$refs.buttonMessage
        let currentChatOutput = this.$store.getters.getCurrentText
        this.chatOutputs = this.$store.getters.getOutputText
        let messagesBot = localStorage.getItem('messagesBot')
        messagesBot = JSON.parse(messagesBot)
        if(!messagesBot || messagesBot.length < 7){
            await this.addOutputMessage(currentChatOutput.text, 4000)
            do {
                await new Promise(resolve => setTimeout(resolve, 4000));
                await this.addOutputMessage(this.$store.getters.getCurrentText.text, 4000)
            } while (this.chatOutputsIndex < this.chatOutputs.length);
            this.removeDisabled(button)
            Bus.$emit('showInfoInitial')
            await this.alertNewPlayers()
            await this.addMessagesPlayers()
        }
        Bus.$emit('showInfoInitial')
        let chatMessages = document.querySelector('.chat-body')
        let self = this
        this.addDisabled(button)
        input.addEventListener('input', () => {
            self.scrollChat(50)
            if(input.value == ''){
                self.addDisabled(button)
                return 
            }
            self.removeDisabled(button)
        })
    },
    methods: {
        async alertNewPlayers(){
            const { group, player } = await this.$store.getters.getSimple(['group', 'player'])
            if(!group){
                return  
            }
            const currentGroup = group.filter(playerGroup => {
                return playerGroup.id != player.id
            })

            currentGroup.forEach(player => {
                // console.log("player: ", player)
                this.$emit('newPlayerMessage', player.name)
            })
        },
        addMessage(message){
            let input = this.$refs.inputMessage
            let button = this.$refs.buttonMessage
            input.value = `${input.value}${message}`
            // input.focus()
            this.removeDisabled(button)
        },
        addDisabled(button){
            button.setAttribute('disabled', 'true')
            button.style.backgroundColor ='#47474'
            button.classList.add('disabled')
            this.buttonStatus = 'disabled'
        },
        removeDisabled(button){
            button.style.backgroundColor  = this.colors.secondary
            button.removeAttribute('disabled')
            button.classList.remove('disabled')
            this.buttonStatus = 'able'
        },
        sendMessage(){
            let button = this.$refs.buttonMessage
            if(inputMessage.value == '' || this.buttonStatus == 'disabled'){
                return
            }
            let message = inputMessage.value
            this.$emit('sendMessage', message)
            inputMessage.value = ''
            inputMessage.focus()
            this.scrollChat(10)
            this.addDisabled(button)
        },
        async addOutputMessage(messages, timeout){
            let button = this.$refs.buttonMessage
            this.addDisabled(button)
            for (const message of messages) {
                await new Promise(resolve => setTimeout(resolve, 4000));
                this.$emit('botMessages', message)
                // this.scrollChat(10)     
            }
            this.chatOutputsIndex++
            this.$store.commit('SET_OUTPUT_CHAT_MESSAGES_INDEX', this.chatOutputsIndex)
            // console.log('Index: ', this.chatOutputsIndex)
            // console.log('chatOutputs: ', this.chatOutputs.length)
        },
        scrollChat(velocidade){
            let chatMessages = document.querySelector('.chat-messages');
            setTimeout(function(){ 
                chatMessages.scrollTop = chatMessages.scrollHeight +  1000000;
            }, velocidade);
        },
        toggleEmoticonsKeyboard(){
            Bus.$emit('toggleEmoticonsKeyboard')
        },
        addMessagesPlayers(){
            setTimeout(()=> {
                let messages = localStorage.getItem('messagesCache')
                messages = JSON.parse(messages)
                messages.forEach(message => {
                    this.$store.commit('PUSH_MESSAGE', message)
                })
            }, 1500)
        }
    }
}
</script>
<style lang="scss">
    
</style>
